<template>
  <div class="min-h-screen flex">
    <div class="flex-1 flex flex-col justify-center px-8 lg:px-24 bg-white">
      <div class="max-w-md w-full mx-auto text-center">
        <img src="@/assets/logo_red_2.png" class="mx-auto h-20 lg:h-30 w-auto mb-2" />
        <h2 class="text-4xl font-black text-gray-900 mb-2">¡Hola de nuevo!</h2>
        <p class="text-gray-500 mb-8">Ingresa tus credenciales para continuar tu aventura.</p>
      </div>

      <div class="max-w-md w-full mx-auto">
        <form @submit.prevent="handleLogin" class="space-y-4">
          <div>
            <label class="block text-sm font-bold mb-2">Usuario o Correo</label>
            <input
              v-model="form.username"
              type="text"
              required
              placeholder="Tu email o usuario"
              class="w-full p-4 bg-gray-50 border border-gray-100 rounded-2xl focus:ring-2 focus:ring-blue-400 outline-none"
            />
          </div>

          <div>
            <div class="flex justify-between items-center mb-2">
              <label class="block text-sm font-bold">Contraseña</label>
              <router-link to="/forgot-password" class="text-xs font-bold text-romance-red hover:underline">
                ¿Olvidaste tu contraseña?
              </router-link>
            </div>

            <div class="relative">
              <input
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                required
                placeholder="••••••••"
                class="w-full p-4 pr-12 bg-gray-50 border border-gray-100 rounded-2xl focus:ring-2 focus:ring-blue-400 outline-none"
              />
              <button
                type="button"
                @click="showPassword = !showPassword"
                class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-blue-500 transition-colors"
              >
                <span v-if="showPassword">🙈</span>
                <span v-else>👁️</span>
              </button>
            </div>
          </div>

          <button
            type="submit"
            :disabled="loading"
            class="w-full bg-gradient-to-r from-romance-red to-blue-500 text-white font-bold py-4 rounded-2xl shadow-lg hover:opacity-90 transition disabled:opacity-50 mt-2"
          >
            {{ loading ? 'Entrando...' : 'Iniciar Sesión' }}
          </button>
        </form>

        <p class="mt-8 text-center text-sm text-gray-500">
          ¿Aún no tienes cuenta?
          <router-link to="/register" class="text-romance-red font-bold">Regístrate gratis</router-link>
        </p>
      </div>
    </div>

    <div class="hidden lg:block lg:flex-1 bg-pink-100 relative overflow-hidden">
      <img src="@/assets/img/front-img-signup.png" class="absolute inset-0 w-full h-full object-cover mix-blend-multiply opacity-60">
      <div class="absolute inset-0 flex items-center justify-center p-12 text-center">
        <h3 class="text-5xl font-black text-white drop-shadow-xl italic">"Encontré a alguien que realmente me escucha."</h3>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/api'
import Swal from 'sweetalert2'

const router = useRouter()
const loading = ref(false)
const showPassword = ref(false) // Estado para el toggle del ojo

const form = ref({
  username: '',
  password: ''
})

const handleLogin = async () => {
  loading.value = true

  Swal.fire({
    title: 'Validando credenciales',
    didOpen: () => { Swal.showLoading() },
    allowOutsideClick: false,
    customClass: { popup: 'rounded-[2rem]' }
  })

  try {
    const response = await api.post('/login', {
      username: form.value.username,
      password: form.value.password
    })

    const { token, id, full_name, role_id, email, is_premium, gender, interested_in } = response.data

    if (token) {
        localStorage.setItem('token', token)
        localStorage.setItem('user', JSON.stringify({ id, full_name, role_id, email, is_premium, gender, interested_in}))

        Swal.close()
        router.push('/app')
    }
  } catch (error) {
    console.error("Error en login:", error)

    Swal.fire({
      icon: 'error',
      title: 'Acceso denegado',
      text: error.response?.data?.error || 'Revisá tus datos e intentá de nuevo.',
      confirmButtonColor: '#ec4899',
      customClass: { popup: 'rounded-[2rem]' }
    })
  } finally {
    loading.value = false
  }
}
</script>